<template>
    <ul class="pagination justify-content-end">
        <li v-if="hasHiddenPages && showFirstLast && pagination.current_page > 1" class="page-item" >
            <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="gotoFirstPage" class="page-link">
                <span aria-hidden="true">First</span>
            </a>
        </li>
        <li v-if="pagination.current_page > 1" class="page-item" >
            <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)" class="page-link">
                <span aria-hidden="true">«</span>
            </a>
        </li>
        <li v-for="(page, index) in pagesNumber" :class="{'active': page == pagination.current_page}" v-bind:key="index" class="page-item">
            <a href="javascript:void(0)" v-on:click.prevent="changePage(page)" class="page-link">{{ page }}</a>
        </li>
        <li v-if="pagination.current_page < pagination.last_page" class="page-item">
            <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)" class="page-link">
                <span aria-hidden="true">»</span>
            </a>
        </li>
        <li v-if="hasHiddenPages && showFirstLast && pagination.current_page < pagination.last_page" class="page-item">
            <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="gotoLastPage" class="page-link">
                <span aria-hidden="true">Last</span>
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'pagination',
    props: {
        pagination: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 4
        },
        showFirstLast: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pagesNumber() {
            if ( ! this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + (this.offset * 2);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            for (let page = from; page <= to; page++){
                pagesArray.push(page);
            }
            return pagesArray;
        },
        hasHiddenPages() {
            if (this.pagesNumber[0] > 1) {
                return true;
            }

            if (this.pagesNumber[this.pagesNumber.length - 1] < this.pagination.last_page) {
                return true;
            }

            return false;

        }
    },
    methods: {
        changePage(page) {
            this.pagination.current_page = page;
            this.$emit('paginate', page);
        },
        gotoFirstPage() {
            this.changePage(1);
        },
        gotoLastPage() {
            this.changePage(this.pagination.last_page);

        }
    }
}
</script>
